import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from '../router';
import { TimetableSearchBanner } from '../views';
import i18n from '../i18n';
import timetableSearchBannerConfig from './TimetableSearchBannerConfig';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(TimetableSearchBanner, timetableSearchBannerConfig)
  .use(router)
  .use(pinia)
  .use(i18n)
  .mount('#timetable-search-banner');
